import {  certificate } from '../actions/constants'

const initState = {
    loading: false,
    certificate: [],
};

export default (state = initState, action) => {

    switch (action.type) {

        case certificate.GET_CERTIFICATE_REQUEST:
            state = {
                ...state,
                loading: true
            };
            break;

        case certificate.GET_CERTIFICATE_SUCCESS:
            state = {
                ...state,
                certificate: action.payload.certificate,
                loading: false
            };
            break;

        case certificate.GET_CERTIFICATE_FAILURE:
            state = {
                ...initState,
            };
            break;
    }
    return state
};
